export const MAPBOX_TOKEN = window.App.Mapbox ? window.App.Mapbox.token : null;
export const MAPBOX_STYLE = window.App.Mapbox ? window.App.Mapbox.style : null;
